document.addEventListener("DOMContentLoaded", function () {
  const openPrimaryMenuButtons =
    document.querySelectorAll(".js-open-main-menu");
  const closePrimaryMenuButtons = document.querySelectorAll(
    ".js-close-main-menu"
  );

  openPrimaryMenuButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      document.body.classList.add("primary-menu-open");
    });
  });

  closePrimaryMenuButtons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      document.body.classList.remove("primary-menu-open");
    });
  });

//   Handle the top bar close button
  const topBarIcons = document.querySelectorAll(".top-bar i");

  topBarIcons.forEach((icon) => {
    icon.addEventListener("click", () => {
      const topBar = icon.closest(".top-bar");
      if (topBar) {
        topBar.style.display = "none";
      }
    });
  });
});
